import { useI18next } from 'gatsby-plugin-react-i18next';
import React, { useEffect, useState } from 'react';
import { useFetchContactDetails } from '../../../hooks/useFetchContactDetails';
import { ContactDataWrapper } from './ContactDataStyle';

const ContactData = () => {
    const { language } = useI18next();
    const [contactData, setContactData] = useState();

    const getContactData = async (): Promise<void> => {
        const data = await useFetchContactDetails(language, 'Contact');
        setContactData(data);
    };

    useEffect(() => {
        getContactData();
    }, []);

    return <ContactDataWrapper dangerouslySetInnerHTML={{ __html: contactData }}></ContactDataWrapper>;
};

export default ContactData;
